import { render, staticRenderFns } from "./StudyPlansTableTerms.vue?vue&type=template&id=788a1838&scoped=true&"
import script from "./StudyPlansTableTerms.vue?vue&type=script&lang=js&"
export * from "./StudyPlansTableTerms.vue?vue&type=script&lang=js&"
import style0 from "./StudyPlansTableTerms.vue?vue&type=style&index=0&id=788a1838&scoped=true&lang=scss&"
import style1 from "./StudyPlansTableTerms.vue?vue&type=style&index=1&id=788a1838&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788a1838",
  null
  
)

export default component.exports